import axios from 'axios';

export const API_URL = process.env.API_URL || '/api';

export const uploadImages = (formData) => {
  return axios.post(`${API_URL}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getFiles = () => {
  return axios.get(`${API_URL}/files`);
};

export const classifyImage = (filename) => {
  return axios.post(`${API_URL}/classify/${filename}`);
};

export const clearUploads = () => {
  return axios.delete(`${API_URL}/clear`);
};

export const reloadSamples = () => {
  return axios.post(`${API_URL}/reload-samples`);
};